import { useCallback, useRef } from "preact/hooks";

const useTimeout = (ms: number) => {
    const id = useRef(-1);

    const set = useCallback(
        (cb: (() => void) | false, newMs: number = ms) => {
            if (id.current !== -1) {
                window.clearTimeout(id.current);
            }

            if (typeof cb === "function") {
                id.current = window.setTimeout(cb, newMs);
            }
        },
        [ms],
    );

    return set;
};

export default useTimeout;
